import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { Form } from "antd";
import { Rule } from "antd/es/form";
import React, { useMemo, useState } from "react";

type Props = {
  type?: React.HTMLInputTypeAttribute | undefined;
  style?: React.CSSProperties | undefined;
  className?: string;
  name?: string | undefined;
  placeholder?: string | undefined;
  rules?: Rule[] | undefined;
  styleFormItem?: React.CSSProperties | undefined;
  validateTrigger?: string;
};
const AuthInput = ({
  type,
  className,
  style,
  name,
  placeholder,
  styleFormItem,
  rules,
  validateTrigger,
}: Props) => {
  const [isShow, setIsShow] = useState<boolean>(false);
  const renderEye = useMemo(() => {
    if (isShow) {
      return (
        <EyeOutlined
          style={{ opacity: 0.5 }}
          onClick={() => {
            setIsShow((prev: boolean) => !prev);
          }}
        />
      );
    }
    return (
      <EyeInvisibleOutlined
        style={{ opacity: 0.5 }}
        onClick={() => {
          setIsShow((prev: boolean) => !prev);
        }}
      />
    );
  }, [isShow]);
  return (
    <Form.Item
      validateTrigger={validateTrigger}
      validateFirst="parallel"
      name={name}
      rules={rules}
      style={styleFormItem}
    >
      <div className={`auth_input_wrapper`}>
        <input
          className={`auth_input ${className || ""}`}
          style={style}
          type={type === "password" ? (isShow ? "text" : "password") : type}
          name={name}
          id={name}
          placeholder="a"
        ></input>
        <label
          style={{ maxWidth: "60%" }}
          htmlFor={name}
          className="auth_input_wrapper_label"
        >
          {placeholder}
        </label>
        {type === "password" && (
          <span
            style={{
              position: "absolute",
              margin: 0,
              top: 0,
              right: 4,
              zIndex: 10,
              userSelect: "none",
            }}
          >
            {renderEye}
          </span>
        )}
      </div>
    </Form.Item>
  );
};

export default AuthInput;
